module.exports = __webpack_public_path__ + "static/media/chat.5cd5a1fc.svg";